/* eco-core.js — Capa de lógica Ecochic sobre Eurus (fase 1).
   Puente de datos + perfil y encaje + pintado de etiquetas «para tu perfil».
   Portado de web-v3 (app.js:6-100, js/ui.js) con las correcciones del anexo de
   FLUJO_FRONTEND_ECOCHIC_v1.md: defecto 3 (alcohol en todas las apariciones) y defecto 9
   (nivel «Revisar para ti» alcanzable, prioridad avoid > caution > ideal > apt > none).
   Datos: #eco-product (ficha), script.eco-product-card (cards), #eco-ingredients (metaobjetos).
   Perfil y personalización en el navegador: eco_profile, eco_perso (dato de salud, no sale del dispositivo). */
(function () {
  'use strict';

  function na(s) { return (s == null ? '' : String(s)).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function esc(s) { return (s == null ? '' : String(s)).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function cap(s) { s = s == null ? '' : String(s); return s.charAt(0).toUpperCase() + s.slice(1); }
  /* fecha local AAAA-MM-DD (defecto 7): toISOString() da la fecha UTC y cambia de día de madrugada */
  function today() { var d = new Date(); return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
  function readJSON(el) { try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } }

  /* almacenamiento seguro: sin localStorage funciona en memoria durante la sesión (web-v3/app.js:12-21) */
  var MEM = {};
  var LS = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return MEM[k] == null ? null : MEM[k]; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) { MEM[k] = v; } },
    del: function (k) { try { window.localStorage.removeItem(k); } catch (e) { delete MEM[k]; } }
  };

  /* ---------- datos ---------- */
  var ING = readJSON(document.getElementById('eco-ingredients')) || [];
  var nameBySlug = {};
  ING.forEach(function (i) { nameBySlug[i.slug] = i.nombre; });
  var P = {}, EX = {};
  function toP(d) {
    if (!d || !d.handle) return null;
    if (P[d.handle] && (P[d.handle].inci || !d.custom || !d.custom.inci)) return P[d.handle];
    var c = d.custom || {};
    var p = { h: d.handle, t: d.title || '', desc: d.description || '', inci: c.inci || '', type: d.product_type || '', tags: d.tags || [], brand: d.vendor || '' };
    P[p.h] = p;
    EX[p.h] = { activos: (c.activos_clave || []).map(function (s) { return nameBySlug[s] || s; }), piel: c.tipos_piel || [] };
    return p;
  }

  /* ---------- perfil (web-v3/app.js:23-100) ---------- */
  var PROF = null, PERSO = true, ACC = null, cbs = [];
  /* Ajuste del tema «Activar el perfil de piel» (ECO_DATA.perfil): apagado, nunca hay perfil, así que nada se personaliza */
  var PERFIL_OFF = !!(window.ECO_DATA && ECO_DATA.perfil === false);
  function load() {
    try { PROF = PERFIL_OFF ? null : JSON.parse(LS.get('eco_profile') || 'null'); } catch (e) { PROF = null; }
    try { ACC = JSON.parse(LS.get('eco_account') || 'null'); } catch (e) { ACC = null; }
    var v = LS.get('eco_perso'); PERSO = v === null ? true : v === '1';
  }
  load();
  function fire() { cbs.forEach(function (c) { try { c(); } catch (e) {} }); }

  /* listas INCI, vocabulario y tipos: metaobjetos «Lista INCI», «Vocabulario» y «Tipo de producto» (window.ECO_DATA) */
  var D = window.ECO_DATA || {};
  function inciHas(text, clave) { return !!(D.has && D.has(text, D.list(clave))); }
  var SKIN_KEYS = (D.group ? D.group('piel_catalogo') : []).map(function (v) { return v.key; });
  var ACCESSORY_TYPES = Object.keys(D.tipos || {}).filter(function (k) { return D.tipos[k].accesorio; }).map(function (k) { return D.tipos[k].interno || k; });
  var SAFETY_SENS = ['fragancia', 'aceites_esenciales', 'alcohol', 'frutos_secos'];

  /* Defecto 3 corregido: se revisan TODAS las apariciones de «alcohol» del INCI. */
  function hasDryingAlcohol(inci) {
    if (/alcohol\s+denat/.test(inci)) return true;
    var re = /([a-z]+)\s+alcohol|\balcohol\b/g, m;
    while ((m = re.exec(inci))) { if (D.list('alcohol_graso').indexOf(m[1] || '') < 0) return true; }
    return false;
  }
  function prodActives(p) {
    var hay = na((EX[p.h] && EX[p.h].activos || []).join(' ')) + ' ' + na(p.inci) + ' ' + na(p.desc) + ' ' + na(p.t);
    return ING.filter(function (ing) {
      var k = na(ing.nombre).split(' ')[0], i = na(ing.inci).split('/')[0].trim();
      return (k.length > 3 && hay.indexOf(k) >= 0) || (i.length > 4 && hay.indexOf(i) >= 0);
    });
  }
  function prodSkin(p) {
    var s = ((EX[p.h] && EX[p.h].piel) || []).slice(), t = na((p.tags || []).join(' ')) + ' ' + na(p.desc);
    SKIN_KEYS.forEach(function (k) { if (t.indexOf('piel ' + k) >= 0) s.push(k); });
    return s;
  }
  /* p.type puede llegar como product_type de Shopify o como tipo interno: vale cualquiera de los dos */
  function isAccessory(p) {
    if (!p || !p.type) return false;
    var t = D.tipo ? D.tipo(p.type) : null;
    if (t && t.accesorio) return true;
    return ACCESSORY_TYPES.indexOf(p.type) >= 0 || Object.keys(D.tipos || {}).some(function (k) { return D.tipos[k].accesorio && na(k) === na(p.type); });
  }
  /* permiso de guardado (EcoConsent, eco-consent.js): sin el módulo, no se guarda */
  function consent(f) { return !!(window.EcoConsent && EcoConsent.has(f)); }
  function withConsent(f, run) { if (consent(f)) { run(); return; } if (window.EcoConsent) EcoConsent.ask(f).then(run, function () {}); }
  function isService(p) { return !!(D.isService && D.isService(p.h)); } /* conceptos de envío: sin etiqueta (plan v2 §3.1) */

  var Profile = {
    get: function () { return PROF; },
    active: function () { return !!PROF; },
    on: function (cb) { cbs.push(cb); },
    personalized: function () { return PERSO && !!PROF; },
    setPersonalized: function (v) { PERSO = !!v; if (consent('perfil_piel')) LS.set('eco_perso', PERSO ? '1' : '0'); fire(); }, // eco_perso es de la finalidad «perfil_piel»
    /* cuenta: la de Shopify (eco_account la rellena EcoStore con el cliente con sesión) */
    account: function () { return ACC; },
    login: function (n, e) { ACC = { name: n || '', email: e || '' }; LS.set('eco_account', JSON.stringify(ACC)); fire(); },
    logout: function () { ACC = null; if (window.EcoStore && EcoStore.signedIn()) { EcoStore.logout(); return; } LS.del('eco_account'); fire(); },
    /* C362: sin permiso «perfil_piel» no se escribe nada: devuelve false y avisa con eco:consent-needed */
    enabled: function () { return !PERFIL_OFF; },
    save: function (pr) {
      if (PERFIL_OFF) return false;
      if (!consent('perfil_piel')) { try { document.dispatchEvent(new CustomEvent('eco:consent-needed', { detail: { finalidad: 'perfil_piel' } })); } catch (e) {} return false; }
      PROF = pr; LS.set('eco_profile', JSON.stringify(pr)); if (!ACC && pr && pr.name) { ACC = { name: pr.name, email: pr.email || '' }; LS.set('eco_account', JSON.stringify(ACC)); } fire(); return true;
    },
    clear: function () { PROF = null; LS.del('eco_profile'); fire(); },
    evaluate: function (p) {
      var neutral = { status: 'neutral', reasons: [], good: [], caution: [] };
      if (!this.personalized() || !p) return neutral;
      var inci = na(p.inci) + ' ' + na((EX[p.h] && (EX[p.h].activos || []).join(' ')) || '');
      var text = inci + ' ' + na(p.desc) + ' ' + na(p.t) + ' ' + na((p.tags || []).join(' '));
      var sens = PROF.sensitivities || [], reasons = [], good = [], caution = [];
      if (PROF.pregnant && inciHas(inci, 'retinoides')) reasons.push(EcoT('core.contiene_retinoides_bakuchiol_se_desac'));
      if (sens.indexOf('frutos_secos') >= 0 && inciHas(inci, 'frutos_secos')) reasons.push(EcoT('core.contiene_aceite_de_frutos_secos_y_has'));
      if ((sens.indexOf('fragancia') >= 0 || sens.indexOf('aceites_esenciales') >= 0) && (inciHas(inci, 'perfume') || (D.alergeno && D.alergeno(p.inci)) || inciHas(text, 'aceite_esencial')))
        reasons.push(EcoT('core.contiene_fragancia_o_alergenos_de_perf'));
      if (sens.indexOf('alcohol') >= 0 && hasDryingAlcohol(inci)) reasons.push(EcoT('core.incluye_alcohol_potencialmente_secante'));
      /* Defecto 9, caso 1: composición sin verificar */
      var declares = PROF.pregnant || sens.some(function (s) { return SAFETY_SENS.indexOf(s) >= 0; });
      if (declares && !p.inci && !isAccessory(p)) caution.push({ nombre: '', porque: EcoT('core.composicion_sin_verificar_revisa_la_et') });
      /* Defecto 9, caso 2: retinoide solo en el texto (título o descripción), no en el INCI */
      var txtOnly = na(p.t) + ' ' + na(p.desc);
      if (PROF.pregnant && !inciHas(inci, 'retinoides') && inciHas(txtOnly, 'retinoides'))
        caution.push({ nombre: '', porque: EcoT('core.retinoide_evitar_en_embarazo') });
      prodActives(p).forEach(function (ing) {
        var pp = (ing.para_piel || []).map(na);
        var fs = pp.indexOf(na(PROF.skin)) >= 0 || pp.indexOf('todas') >= 0;
        var fc = (ing.dolencias || []).some(function (d) { return (PROF.concerns || []).some(function (c) { return na(d).indexOf(na(c)) >= 0 || na(c).indexOf(na(d)) >= 0; }); });
        if (fs || fc) good.push({ nombre: ing.nombre, porque: (fc ? EcoT('core.encaja_con_tu_objetivo') : EcoT('core.va_bien_para_tu_tipo_de_piel')) + ' — ' + ((ing.que_hace || '').split('.')[0]) + '.', slug: ing.slug, url: ing.url });
      });
      return { status: reasons.length ? 'avoid' : (good.length ? 'apt' : 'neutral'), reasons: reasons, good: good.slice(0, 6), caution: caution.slice(0, 4) };
    },
    isIdeal: function (p) {
      if (!this.personalized() || !p) return false;
      if (prodSkin(p).map(na).indexOf(na(PROF.skin)) >= 0) return true;
      var hay = na((p.tags || []).join(' ')) + ' ' + na(p.desc) + ' ' + na(p.t);
      return (PROF.concerns || []).some(function (c) { return c && hay.indexOf(na(c)) >= 0; });
    },
    relevantIngredient: function (ing) {
      if (!this.personalized() || !ing) return false;
      return (ing.para_piel || []).map(na).indexOf(na(PROF.skin)) >= 0 || (ing.dolencias || []).some(function (d) { return (PROF.concerns || []).some(function (c) { return na(d).indexOf(na(c)) >= 0; }); });
    },
    /* Jerarquía corregida: avoid > caution > ideal > apt > none */
    fitStatus: function (p) {
      var none = { level: 'none', label: '', reason: '', icon: '' };
      if (!this.personalized() || !p || isService(p)) return none;
      var ev; try { ev = this.evaluate(p); } catch (e) { ev = null; }
      ev = ev || { reasons: [], good: [], caution: [] };
      if (ev.status === 'avoid') return { level: 'avoid', label: EcoT('core.no_apto_para_tu_perfil'), reason: ev.reasons[0] || EcoT('core.contiene_algo_que_has_indicado_evitar'), icon: '•' }; // C364: sin «⚠» (Glosario §5)
      if (ev.caution.length) return { level: 'caution', label: EcoT('core.revisar_para_ti'), reason: ev.caution[0].porque || EcoT('core.contiene_algo_que_conviene_que_revises'), icon: '•' };
      var id = false; try { id = this.isIdeal(p); } catch (e) {}
      if (id) return { level: 'ideal', label: EcoT('core.ideal_para_ti'), reason: (ev.good[0] && ev.good[0].porque) || EcoT('core.encaja_con_tu_tipo_de_piel_y_tus_objet'), icon: '★' };
      if (ev.good.length) return { level: 'apt', label: EcoT('core.apto_para_ti'), reason: ev.good[0].porque || EcoT('core.tiene_activos_que_encajan_con_tu_perfi'), icon: '✓' };
      return none;
    }
  };

  /* ---------- pintado (web-v3/js/ui.js) ---------- */
  var COMPACT = { ideal: EcoT('core.ideal'), apt: EcoT('core.apto'), caution: EcoT('core.revisar'), avoid: EcoT('core.no_apto') };
  function fitTag(p, compact) {
    var s = Profile.fitStatus(p); if (s.level === 'none') return '';
    return '<span class="fit-tag fit-' + s.level + (compact ? ' fit-compact' : '') + '" title="' + esc(s.reason) + '"><i aria-hidden="true">' + esc(s.icon) + '</i><span>' + esc(compact ? COMPACT[s.level] : s.label) + '</span></span>';
  }
  function fitBanner(p, foot, footPreg) {
    var s = Profile.fitStatus(p); if (s.level === 'none') return '';
    var ev = Profile.evaluate(p);
    /* «A vigilar» (FLUJO F4 R9): las cautelas sin nombre (retinoide en embarazo, composición sin verificar) también se pintan, con su motivo como línea */
    var good = ev.good.slice(0, 4), cau = ev.caution.filter(function (x) { return x.nombre || x.porque; }).slice(0, 3);
    function col(lbl, arr) {
      return '<div class="fb-col"><p class="fb-lbl">' + esc(lbl) + '</p><ul>' + arr.map(function (x) {
        if (!x.nombre) return '<li><span class="fb-why">' + esc(cap(x.porque)) + '</span></li>';
        var n = x.url ? '<a href="' + esc(x.url) + '">' + esc(x.nombre) + '</a>' : esc(x.nombre);
        return '<li>' + n + (x.porque ? ' — <span class="fb-why">' + esc(x.porque) + '</span>' : '') + '</li>';
      }).join('') + '</ul></div>';
    }
    var cols = (good.length ? col(EcoT('core.activos_que_te_encajan'), good) : '') + (cau.length ? col(EcoT('core.a_vigilar'), cau) : '');
    return '<div class="fit-banner fit-' + s.level + '"><div class="fb-head"><i class="fb-icon" aria-hidden="true">' + esc(s.icon) + '</i><div><strong>' + esc(s.label) + '</strong>' +
      (s.reason ? '<p class="fb-reason">' + esc(s.reason) + '</p>' : '') + '</div></div>' + (cols ? '<div class="fb-cols">' + cols + '</div>' : '') +
      (foot ? '<p class="fb-foot">' + esc(foot) + '</p>' : '') +
      (PROF && PROF.pregnant && footPreg ? '<p class="fb-foot">' + esc(footPreg) + '</p>' : '') + '</div>'; // Aviso B7 (C365)
  }

  function renderProduct() {
    var box = document.getElementById('eco-fit'); if (!box) return;
    if (PERFIL_OFF) { box.innerHTML = ''; box.hidden = true; return; } // sin perfil: ni encaje ni invitación a crearlo
    var p = toP(readJSON(document.getElementById('eco-product'))); if (!p) return;
    if (Profile.personalized()) { box.innerHTML = fitBanner(p, box.getAttribute('data-foot'), box.getAttribute('data-foot-pregnancy')); return; }
    var txt = box.getAttribute('data-cta-text'), sub = box.getAttribute('data-cta-sub'), lbl = box.getAttribute('data-cta-label'), url = box.getAttribute('data-cta-url');
    box.innerHTML = txt ? '<div class="fit-cta"><p>' + esc(txt) + (sub ? '<small>' + esc(sub) + '</small>' : '') + '</p>' + (lbl && url ? '<a class="fit-cta__btn" href="' + esc(url) + '">' + esc(lbl) + '</a>' : '') + '</div>' : '';
  }
  function renderCards() {
    document.querySelectorAll('script.eco-product-card').forEach(function (el) {
      var p = toP(readJSON(el)); if (!p) return;
      var slot = el.nextElementSibling && el.nextElementSibling.classList.contains('eco-fit') ? el.nextElementSibling : null;
      if (slot) slot.innerHTML = fitTag(p, true);
    });
  }
  /* «Añadir a mi rutina» en la ficha (FLUJO §5, regla 27): paso «Añadido a mano» en eco_routine, sin duplicar */
  function inRoutine(h) {
    var r = null; try { r = JSON.parse(LS.get('eco_routine') || 'null'); } catch (e) {}
    return !!(r && (r.steps || []).some(function (x) { return x.handle === h || (x.product && x.product.h === h); }));
  }
  function renderRoutineBtn() {
    var box = document.getElementById('eco-routine'); if (!box || box.getAttribute('data-ready')) return;
    if (PERFIL_OFF) { box.hidden = true; return; } // la rutina y el diario guardados viven en Mi cuenta, que sin perfil no los muestra
    var d = readJSON(document.getElementById('eco-product')); if (!d) return;
    box.setAttribute('data-ready', '1');
    var a = function (k) { return box.getAttribute('data-' + k) || ''; };
    box.innerHTML = '<button type="button" class="eco-rt-btn">' + esc(inRoutine(d.handle) ? a('dup') : a('label')) + '</button>' +
      (a('link-label') && a('link-url') ? ' <a class="eco-rt-link" href="' + esc(a('link-url')) + '">' + esc(a('link-label')) + '</a>' : '');
    if (a('diary')) {
      box.insertAdjacentHTML('beforeend', ' <button type="button" class="eco-rt-btn" data-eco-diary>' + esc(a('diary')) + '</button>');
      /* FLUJO §6, regla 10: marca en uso y añade una entrada con la nota fija (cada clic, una entrada) */
      box.querySelector('[data-eco-diary]').addEventListener('click', function () {
        var b = this;
        withConsent('diario', function () { addDiary(b); }); // C366: bloque 4.2 antes de escribir eco_diary / eco_inuse
      });
      function addDiary(b) {
        var h = d.handle, dy = {}, u = [];
        try { dy = JSON.parse(LS.get('eco_diary') || '{}') || {}; } catch (e) {}
        try { u = JSON.parse(LS.get('eco_inuse') || '[]') || []; } catch (e) {}
        (dy[h] = dy[h] || []).push({ fecha: today(), nota: a('diary-note'), reaccion: '' });
        if (u.indexOf(h) < 0) u.push(h);
        LS.set('eco_diary', JSON.stringify(dy)); LS.set('eco_inuse', JSON.stringify(u));
        b.textContent = a('diary-done'); setTimeout(function () { b.textContent = a('diary'); }, 1600);
      }
    }
    box.querySelector('button').addEventListener('click', function () {
      var btn = this;
      if (inRoutine(d.handle)) { btn.textContent = a('dup'); return; }
      withConsent('perfil_piel', function () { addRoutine(btn); }); // C367: bloque 4.1 antes de guardar la rutina (Aviso C3)
    });
    function addRoutine(btn) {
      if (inRoutine(d.handle)) { btn.textContent = a('dup'); return; }
      var r = null; try { r = JSON.parse(LS.get('eco_routine') || 'null'); } catch (e) {}
      if (!r || !Array.isArray(r.steps)) r = { title: EcoT('core.mi_rutina'), steps: [] };
      r.steps.push({ slot: 'producto', label: EcoT('core.anadido_a_mano'), when: EcoT('core.segun_indicacion'), handle: d.handle,
        product: { h: d.handle, t: d.title, img: d.image, price: d.price != null ? ((window.ECO_DATA && ECO_DATA.priceVat ? ECO_DATA.priceVat(d.price) : d.price) / 100).toFixed(2) : '' } });
      LS.set('eco_routine', JSON.stringify(r));
      btn.textContent = a('added');
    }
  }
  /* Señales del perfil para el Estándar (FLUJO §8, regla 1): solo con personalización encendida */
  function signals() {
    if (!Profile.personalized()) return {};
    var s = PROF.sensitivities || [];
    return { frag: s.indexOf('fragancia') >= 0 || s.indexOf('aceites_esenciales') >= 0, alcohol: s.indexOf('alcohol') >= 0, nuts: s.indexOf('frutos_secos') >= 0, pregnant: !!PROF.pregnant };
  }
  /* Tarjetas con «Resaltar según el perfil» (jm-theme-card-grid): clase, «te afecta» y nota de la sección */
  function renderAffects() {
    var sig = signals();
    document.querySelectorAll('[data-eco-affects]').forEach(function (li) {
      var on = !!sig[li.getAttribute('data-eco-affects')];
      li.classList.toggle('eco-affects-on', on);
      var b = li.querySelector('.eco-affects-badge'); if (b) b.hidden = !on;
    });
    document.querySelectorAll('.eco-affects-note').forEach(function (n) {
      var sec = n.closest('.jm-sec'); n.hidden = !(sec && sec.querySelector('.eco-affects-on'));
    });
  }
  function renderAll() { try { renderProduct(); } catch (e) {} try { renderCards(); } catch (e) {} try { renderRoutineBtn(); } catch (e) {} try { renderAffects(); } catch (e) {} }

  Profile.on(renderAll);
  window.addEventListener('storage', function (e) { if (e.key === 'eco_profile' || e.key === 'eco_perso' || e.key === 'eco_account') { load(); renderAll(); } });
  /* cards que llegan después (filtros, paginación, vista rápida) */
  var mo = new MutationObserver(function (m) {
    var hasCards = m.some(function (r) {
      return Array.prototype.some.call(r.addedNodes, function (n) {
        return n.nodeType === 1 && !(n.closest && n.closest('.eco-fit')) && (n.matches('script.eco-product-card') || (n.querySelector && n.querySelector('script.eco-product-card')));
      });
    });
    if (hasCards) renderCards();
  });

  function start() { renderAll(); mo.observe(document.body, { childList: true, subtree: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  // con un backend remoto (Supabase), los datos llegan después de pintar: se releen y se repinta
  document.addEventListener('eco:store-ready', function () {
    try { PROF = PERFIL_OFF ? null : JSON.parse(LS.get('eco_profile') || 'null'); } catch (e) { PROF = null; }
    PERSO = LS.get('eco_perso') !== '0';
    try { ACC = JSON.parse(LS.get('eco_account') || 'null'); } catch (e) {}
    fire();
  });
  window.Eco = { Profile: Profile, fitTag: fitTag, fitBanner: fitBanner, signals: signals, data: { P: P, EX: EX, ING: ING, toP: toP }, na: na, esc: esc, LS: LS };
  window.Profile = window.Profile || Profile;
})();
